export const returnClasses = (isRightMenu, isCenter) => {
    if (isCenter) {
        return ''
    } else {
        return isRightMenu ? 'school-waitlist' : '';
    }
}
